import { render, staticRenderFns } from "./FTPViewer.vue?vue&type=template&id=4a88b65d&"
import script from "./FTPViewer.vue?vue&type=script&lang=js&"
export * from "./FTPViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports